import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// Include custom CSS
import ProgressBar from '../../../../ReusableBlocks/ProgressBar';

const TeamReportsCarousel = ({ teamLearningStatus = [] }) => {
  console.log('Received teamLearningStatus:', teamLearningStatus);

  const [selectedMember, setSelectedMember] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState(''); // For filtering by status
  const [currentPage, setCurrentPage] = useState(1); // For pagination
  const recordsPerPage = 5; // Records to display per page

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const openModal = (memberName) => {
    const member = teamLearningStatus.find((member) => Object.keys(member)[0] === memberName);
    setSelectedMember(member);
    setIsModalOpen(true);
    setCurrentPage(1); // Reset pagination to the first page
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSearchQuery('');
    setStatusFilter('');
  };

  const getFilteredMicrocerts = (microcerts) => {
    const statusOrder = {
      Completed: 1,
      'In Progress': 2,
      'Not Completed': 3,
    };

    let filtered = microcerts.filter(
      (cert) =>
        cert.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        cert.trackTitle.toLowerCase().includes(searchQuery.toLowerCase())
    );

    if (statusFilter) {
      filtered = filtered.filter((cert) => cert.status === statusFilter);
    }

    return filtered.sort((a, b) => statusOrder[a.status] - statusOrder[b.status]);
  };

  const getPaginatedRecords = (records) => {
    const startIndex = (currentPage - 1) * recordsPerPage;
    return records.slice(startIndex, startIndex + recordsPerPage);
  };

  if (!teamLearningStatus.length) {
    return <p>No team data available</p>;
  }

  return (
    <div>
      <Slider {...settings}>
        {teamLearningStatus.map((member, index) => {
          const memberName = Object.keys(member)[0];
          const memberData = member[memberName];
          return (
            <div key={index}>
              <div className="card-profile">
                <h1 className="card-dummy-profile-content-h1">{memberName}</h1>
                <p className="card-dummy-profile-content-p">
                  Tracks Completed: {memberData['Tracks Completed']}
                </p>
                <ProgressBar
                  progress={(parseInt(memberData['Tracks Completed'].split('/')[0]) / 3) * 100}
                />
                <br></br>

                <p className="card-dummy-profile-content-p">
                  Microcert Completed: {memberData['Microcerts Completed (%)']}%
                </p>
                <ProgressBar
                  progress={(() => {
                    const completion = memberData['Microcerts Completed (%)'];
                    // Assuming the value is a direct percentage
                    if (typeof completion === 'number') {
                      return completion; // Use it directly as percentage
                    }

                    // If it's a string in 'completed/total' format
                    if (typeof completion === 'string' && completion.includes('/')) {
                      const [completed, total] = completion.split('/').map(Number);
                      if (total !== 0) {
                        return (completed / total) * 100; // Calculate percentage
                      }
                    }

                    // Fallback if data is not as expected
                    return 0;
                  })()}
                />




                <button className="team-breakdown-button" onClick={() => openModal(memberName)}>
                  Breakdown
                </button>
              </div>
            </div>
          );
        })}
      </Slider>

      {isModalOpen && selectedMember && (
        <div className="modern-modal-overlay">
          <div className="modern-modal">
            <div className="modern-modal-header">
              <h2 className="modern-modal-title">
                Microcert Details - {Object.keys(selectedMember)[0]}
              </h2>
              <button className="modern-modal-close" onClick={closeModal}>
                ✕
              </button>
            </div>
            <div className="modern-modal-controls">
              <input
                type="text"
                className="modern-modal-search"
                placeholder="Search by Title or Track"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <select
                className="modern-modal-sort"
                onChange={(e) => setStatusFilter(e.target.value)}
                value={statusFilter}
              >
                <option value="">All Statuses</option>
                <option value="Completed">Completed</option>
                <option value="In Progress">In Progress</option>
                <option value="Not Completed">Not Completed</option>
              </select>
            </div>
            <div className="modern-modal-table-container">
              <table className="modern-modal-table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Track Title</th>
                    <th className="status-column">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {getPaginatedRecords(
                    getFilteredMicrocerts(
                      selectedMember[Object.keys(selectedMember)[0]]['List of Microcerts']
                    )
                  ).map((cert, idx) => (
                    <tr key={idx}>
                      <td>{cert.title}</td>
                      <td>{cert.trackTitle}</td>
                      <td
                        className={`status-${cert.status.replace(/\s/g, '-').toLowerCase()}`}
                      >
                        {cert.status}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modern-modal-pagination">
              <button
                className="pagination-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
              >
                &lt;
              </button>
              <span className="pagination-info">
                Page {currentPage} of{' '}
                {Math.ceil(
                  getFilteredMicrocerts(
                    selectedMember[Object.keys(selectedMember)[0]]['List of Microcerts']
                  ).length / recordsPerPage
                )}
              </span>
              <button
                className="pagination-btn"
                disabled={
                  currentPage ===
                  Math.ceil(
                    getFilteredMicrocerts(
                      selectedMember[Object.keys(selectedMember)[0]]['List of Microcerts']
                    ).length / recordsPerPage
                  )
                }
                onClick={() => setCurrentPage((prev) => prev + 1)}
              >
                &gt;
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default TeamReportsCarousel;
